// extracted by mini-css-extract-plugin
export var container = "_49-0";
export var icon = "_49-1";
export var text = "_49-2";